import classNames from 'classnames';
import { ReactNode } from 'react';
import { ISourcedCard } from '../../../Models/CardModels';
import Card from '../../General/Card/Card';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export interface IDraggableCardProps {
  card: ISourcedCard;
  className?: string;
  cardClassName?: string;
  rotation?: number;
  dragGroup?: ISourcedCard[];
  disabled?: boolean;
  isRejected?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
  children?: ReactNode;
}

const DraggableCard = ({
  card,
  className,
  cardClassName,
  rotation,
  dragGroup = [card],
  disabled,
  isRejected,
  ariaLabel,
  onClick,
  children,
}: IDraggableCardProps) => {
  const { active, attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: card.card.cardId,
      data: { cardClassName, rotation, dragGroup },
      disabled: { draggable: disabled, droppable: disabled },
    });
  const isInDraggedGroup = dragGroup.some((c) => c.card.cardId === active?.id);
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      aria-label={ariaLabel}
      onClick={onClick}
      key={card.card.cardId}
      className={classNames(
        'inline-block',
        'touch-none pointer-events-auto',
        className,
        {
          'cursor-pointer': onClick,
          'opacity-0': isInDraggedGroup,
          'motion-safe:animate-reject': isRejected,
        }
      )}
    >
      <Card
        card={card.card}
        className={classNames(cardClassName, {
          'ring-3 ring-danger': isRejected,
        })}
      />
      {children}
    </div>
  );
};

export default DraggableCard;
